import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./teleworksubnav.css"


const teleworksubNav = ( { }) => {

    
    
    return (
        <section className="subnav" id="subNav">
            <div className="containfix">
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/telework/#About">ABOUT</a>
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/telework/#Agenda">AGENDA</a>
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/telework/wrap-up" target="_blank">WRAP-UP</a>
            </div>
         </section>
    )
}

export default teleworksubNav